import { createAuthClient } from "better-auth/react";
import { env } from "@/lib/env";
import { clearAuthToken } from "@/lib/auth-token";

const authClient = createAuthClient({
  baseURL: `${env.FRONTEND__API_URL}/auth`,
  fetchOptions: {
    credentials: "include",
    onResponse: (ctx) => {
      if (String(ctx.request.url).includes("/auth/sign-out")) clearAuthToken();
    },
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;
